import api from '../../utils/api'

const state = {
  organizations: {}
}

const getters = {
}

const actions = {
  insertOrganization ({ commit }, payload) {
    return api('/api/organizations', 'POST', payload)
  },
  getOrganizations ({ commit }, payload) {
    return api('/api/organizations', 'GET', payload)
  },
  getAllOrganizations ({ commit }, payload) {
    return api('/api/organizations/all', 'GET', payload)
  }
}

const mutations = {
}

export default {
  state,
  mutations,
  getters,
  actions
}
